import { useMemo } from "react";
import { openItem } from "@/store/uiSlice";
import Price from "@/components/Price";
import {
  ColumnFilled,
  ColumnFree,
  DefaultFilled,
  DefaultFree,
  MediaFilled,
  DefaultText,
  ListText,
  PriceDownText,
  PriceUpText,
  SquareMiddlePrice,
} from "../preview-widget/components";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { Content, OrderItem } from "@/types";
import { getOrderItemPrice } from "@/utils/order";
import { sanitizeNumber } from "@/utils/numbers";
import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import { getThumbnailImage } from "@/utils/media";

interface ListViewProps<I extends Content> {
  items: I[];
  previewWidget: string;
}

const ListView = <I extends Content>({ items = [], previewWidget = "default-filled" }: ListViewProps<I>) => {
  const activeOrganization = useAppSelector((store) => store.ui.activeOrganization);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const PreviewWidget = useMemo(() => {
    switch (previewWidget) {
      case "default-text":
        return DefaultText;
      case "list-text":
        return ListText;
      case "price-down-text":
        return PriceDownText;
      case "price-up-text":
        return PriceUpText;
      case "default-filled":
        return DefaultFilled;
      case "default-free":
        return DefaultFree;
      case "column-filled":
        return ColumnFilled;
      case "column-free":
        return ColumnFree;
      case "media-filled":
        return MediaFilled;
      case "square-middle-price":
        return SquareMiddlePrice;
      default:
        return null;
    }
  }, [previewWidget]);

  const getDescription = ({ description, previewDescription }) => {
    if (previewDescription && typeof previewDescription === "string") {
      return previewDescription;
    }

    if (previewDescription) {
      return parse(description);
    }

    return "";
  };

  return (
    <>
      {items.map((item, index) => {
        return PreviewWidget ? (
          <PreviewWidget
            key={`${item.id}-${index}`}
            title={item.title}
            description={() => getDescription(item as any)}
            schedule={item.schedule}
            price={<Price currency="NIO">{item.price != 0 ? getOrderItemPrice(item as unknown as OrderItem) : sanitizeNumber(item?.startingPrice)}</Price>}
            image={getThumbnailImage({ file: item?.images, organizationId: activeOrganization, size: '150x150' })}
            onClick={(e: any) => {
              e.stopPropagation();
              dispatch(openItem(item));
              navigate(`?itemId=${item.id}`);
            }}
          />
        ) : null;
      })}
    </>
  );
};

export default ListView;
